import { VerifyProvisionalRegistrationTokenWithConnectBoardMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyProvisionalRegistrationTokenWithConnectBoardMutationHandler =
  graphql.mutation<VerifyProvisionalRegistrationTokenWithConnectBoardMutation>(
    "verifyProvisionalRegistrationTokenWithConnectBoard",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          verifyProvisionalRegistrationTokenWithConnectBoard: {
            email: "mock_user@moneyforward.com",
            registrationCode: "mock-registration-code",
            result: true,
          },
        },
      });
    }
  );
